<script setup>
import CameraPrivacy from '@/components/CameraPrivacy.vue'

const props = defineProps({
  readOnlySelection: { type: Boolean, default: false },
  preselectedCameras: { type: [Array, Object, String], default: () => [] },
})

const showPrivacyDialog = defineModel('showPrivacyDialog', { type: Boolean, default: false })
</script>

<template>
  <v-dialog
    v-model="showPrivacyDialog"
    max-width="500"
    width="100%"
  >
    <v-dialog-card class="w-100">
      <CameraPrivacy
        :preselected-cameras="props.preselectedCameras"
        :read-only-selection="props.readOnlySelection"
      />
      <v-divider />
      <v-card-actions class="justify-end">
        <v-btn
          prepend-icon="mdi-close"
          variant="outlined"
          @click="() => (showPrivacyDialog = false)"
        >
          {{ $t('general_interface.buttons.close') }}
        </v-btn>
      </v-card-actions>
    </v-dialog-card>
  </v-dialog>
</template>
